import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { ShowcaseHomePageTwo } from "@/pages/showcase-homepage-two";

export const Route = createFileRoute("/showcase/homepage-2")({
  head: () => {
    const t = i18n.getFixedT("nl", "home");
    const title = `${t("showcase.seo_title")} — 2`;
    const description = `${t("showcase.seo_desc")} ${t("showcase.offer_title")}.`;
    return { meta: [
      { title }, { name: "description", content: description },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: title }, { property: "og:description", content: description },
      { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary_large_image" },
    ] };
  },
  component: ShowcaseHomePageTwo,
});